/** Excel/CSV enrichment strings (extracted to keep en.ts under the size ratchet). */
export const enCsvEnrichment = {
	title: "Excel File Enrichment",
	type: "Type",
	name: "File name",
	amountInCsv: "Lines in Excel",
	downloads: "Download",
	found: "Found",
	processed: "Processed",
	status: "Status",
	search: "Search by filename",
	withEmail: "with email addresses",
	subtitle:
		"Enrich your Excel file with additional information. <br /><br />If you want to enrich a person, the file should contain at least one of the following columns or combinations of columns: <br /><strong>1. linkedinUrl, 2. email, 3. name and companyName</strong>. <br /><br />If you want to enrich a company, the file should contain the following columns: <br /><strong>1. companyLinkedinUrl, 2. website</strong>. <br /><br />If you want to enrich people based on their position in predefined companies, the file should contain the following columns: <br /><strong>1. companyName, 2. title</strong>.",
	create: {
		title: "Create New Excel Enrichment",
		button: "Upload Excel file",
	},
	delete: {
		title: "Delete Excel Enrichment",
	},
	foundFields: "The following fields have been found",
	companyEnrichment:
		"Enough data for to search for people in companies. The following methods can be applied:",
	personByTitle:
		"Enough data for to search for specified positions in companyies. The following methods can be applied:",
	tabs: {
		results: "Results",
		costs: "Costs",
	},
	namePlaceholder: "Name of the Excel Source",
	aiAnalyzing: "AI is analyzing your columns…",
	mappingHint: {
		title: "Map your columns to one of these combinations to enable upload:",
		separator: " + ",
	},
	// PREC-3870: the after-enrichment statistics modal opened from the Added sources table.
	statsModal: {
		title: "XLS Statistics",
		subtitle: "after enrichment",
		close: "Close",
		empty: "No statistics available for this source yet.",
		groupImport: "Import",
		groupScreening: "Job title screening",
		groupCompanies: "Companies",
		groupEnrichment: "Enrichment results",
		rowsDetected: "Rows detected",
		rowsReady: "Rows ready to process",
		// Not "Duplicates detected": the gap between the sheet and the rows that were imported has
		// several causes, and a reset source has no rows at all.
		notImported: "Rows not imported",
		// Deliberately not "New job titles …": job_title_screening is workspace-wide with no link
		// to a file, so which titles were new when this file ran is not recoverable.
		whitelisted: "Job titles whitelisted",
		blacklisted: "Job titles blacklisted",
		companiesFound: "Companies found",
		companiesMerged: "Merged into another company",
		companiesNotFound: "Companies not found",
		companiesExcluded: "Companies excluded",
		companiesPending: "Still processing",
	},
	titleGate: {
		toggleLabel: "Screen job titles before enrichment",
		creditChip: "0.1 credits per new job title",
		tooltipTitle: "Screen titles before enriching.",
		tooltipBody:
			"Each job title is checked against your persona. Off-persona titles (e.g. Head of HR) are disqualified up front, so you never spend full enrichment credits on them. New titles cost 0.1 credit to screen; titles already in your workspace are reused for free — so your lists get cheaper over time.",
		alreadyAnalyzed: "job titles already analyzed",
		newScreened: "new titles will be screened with AI",
		offCopy: "Off — every contact will be enriched.",
		statsTitle: "XLS Statistics",
		rowsDetected: "Rows detected",
		rowsReady: "Rows ready to process",
		duplicates: "Duplicates detected",
		alreadyWhitelisted: "Job titles already whitelisted",
		alreadyBlacklisted: "Job titles already blacklisted",
		// PREC-3870: the company-upload twin of the two job-title rows above.
		alreadyKnownCompanies: "Companies already in Signalist (exact match)",
		newCompanies: "New companies",
		previewButton: "Preview",
		previewTitle: "Preview your list",
		previewSubtitle: "How your contacts will render in Signalist · rows 1–{{shown}} of {{total}}",
		previewFootNote:
			"Showing rows 1–{{shown}} of {{total}} · rendered as Signalist will store them",
		previewConfirm: "Looks good",
		notMapped: "Not mapped",
		screeningOn: "screening on",
	},
};
